import { Controller } from "@hotwired/stimulus"
import ahoy from "ahoy.js"

export default class extends Controller {
  connect() {
    
  }

  trackCta(e) {
    let data = e.currentTarget.dataset
    ahoy.track("cta clicked", { label: data["ctaLabel"], url: data["ctaUrl"], primary: data["primary"] ? true : false })
  }

  get metadata() {
    return JSON.parse(this.element.dataset.metadata);
  }
}